module.exports = __webpack_public_path__ + "img/icon_bonus.a8d9800d.svg";